import { nanoid } from 'nanoid';

export function generateRandomUUID(): string {
  if (crypto && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }

  return nanoid();
}
